import React from 'react';

type StarSize = 'sm' | 'md' | 'lg';

const STAR_SIZE_MAP: Record<StarSize, string> = {
  sm: '1.2rem',
  md: '1.25rem',
  lg: '2.5rem'
};

export interface StarRatingProps {
  rating: number;
  hoverRating?: number;
  maxStars?: number;
  size?: StarSize;
  readOnly?: boolean;
  disabled?: boolean;
  onRate?: (rating: number) => void;
  onHover?: (rating: number) => void;
  onHoverEnd?: () => void;
  className?: string;
  iconClassName?: string;
  ratedColor?: string;
  emptyColor?: string;
}

export const StarRating: React.FC<StarRatingProps> = ({
  rating,
  hoverRating = 0,
  maxStars = 5,
  size = 'md',
  readOnly = false,
  disabled = false,
  onRate,
  onHover,
  onHoverEnd,
  className = 'stars-container',
  iconClassName = '',
  ratedColor = '#ffc107',
  emptyColor = '#e9ecef'
}) => {
  const isDisabled = readOnly || disabled;
  const displayRating = hoverRating || rating;

  return (
    <div className={className} onMouseLeave={isDisabled ? undefined : onHoverEnd}>
      {Array.from({ length: maxStars }, (_, index) => {
        const star = index + 1;
        const isActive = star <= displayRating;

        return (
          <button
            key={star}
            type="button"
            className={`star-button ${isActive ? 'active' : ''}`.trim()}
            onClick={isDisabled ? undefined : () => onRate?.(star)}
            onMouseEnter={isDisabled ? undefined : () => onHover?.(star)}
            disabled={isDisabled}
            aria-label={`Rate ${star} star${star !== 1 ? 's' : ''}`}
          >
            <i
              className={`fa${isActive ? 's' : 'r'} fa-star ${iconClassName}`.trim()}
              style={{
                color: isActive ? ratedColor : emptyColor,
                fontSize: STAR_SIZE_MAP[size]
              }}
            />
          </button>
        );
      })}
    </div>
  );
};

export default StarRating;
